import { useEffect } from 'react';

/**
 * Telas full-screen de auth (login, loading). O zoom de densidade (85% no html)
 * deixa faixa clara à direita se usarmos 100vw — aqui restauramos zoom 1 na rota.
 */
export function useAuthScreenViewport(options?: { darkBackground?: boolean }) {
  const dark = options?.darkBackground ?? false;

  useEffect(() => {
    const html = document.documentElement;
    html.classList.add('klinvia-auth-screen');
    if (dark) html.classList.add('klinvia-auth-screen-dark');

    return () => {
      html.classList.remove('klinvia-auth-screen', 'klinvia-auth-screen-dark');
    };
  }, [dark]);
}
